import { useEffect, useRef, useState } from "react";
import BasicDateCalendar from "../summary/Calendar";
import dayjs from "dayjs";
import { Typography, Backdrop, CircularProgress } from "@mui/material";
import calendericon from "../../../../assets/patientcharts/calendericon.svg";
import axios from "axios";
import CarePlanDynamicModal from "./modals/CarePlanDetailModal";
import CarePlanTable from "./careplantable";
import { whitemic } from "../../../../utils/svgs/svgcode";
import redcircle from "../../../../assets/audio/redcircle.png";
import pause from "../../../../assets/audio/Pause.png";
import play from "../../../../assets/audio/play.png";
import stop from "../../../../assets/audio/ion_stop.png";
import redmic from "../../../../assets/audio/redmic.png";
import {
  enrollPatient,
  fileIcon,
  historyCCM,
  orangeFileIcon,
} from "../tabsvgs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ReactiveWaves from "../../../../streaming/reactivewaves";
import EnrollForm from "./modals/enrollForm";
import AuditTrailModal from "./modals/auditTrailModal";
import DateRangeSelector from "../../../../daterangepicker/DateRangeSelector";
import api from "../../../../api/api.js";
import { BS_BASE } from "../../../../api/bases";
import useNavigationHold from "../../../../utils/useNavigationHold";
import { getPracticeId } from "../../../../config/practice";

const CCmTable = ({ searchDate, data, setIsRecordingDisabled }) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const calendarRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(dayjs(searchDate));
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const audioStreamRef = useRef(null);
const practiseid = getPracticeId();
  const [type, setType] = useState("view");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState("");
  // Audio Recording States
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [recordedAudioBlob, setRecordedAudioBlob] = useState(null);
  // While recording, and while the recording waits in the save dialog, a
  // location switch / expired sign-in waits instead of reloading the page
  // (utils/deferredNavigation).
  useNavigationHold(isRecording || showSaveModal);
  const [recordDuration, setRecordDuration] = useState(0);
  const [showEnrollModal, setShowEnrollModal] = useState(false);
  const [showAuditModal, setShowAuditModal] = useState(false);
const [auditData,setAuditData]=useState([])
  const [patientloading,setpatientloading]=useState(false)
  const [enrollPatientData,setEnrollPatientData]=useState(null)
  const [allauditdata,setAllAuditData]=useState([])
  const timerRef = useRef(null);
  const [showAddModal, setShowAddModal] = useState(false);
  // Date range selector state/handlers
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handledateSelect = () => {
    // Close the calendar on apply; add filtering logic here if needed
    setIsCalendarOpen(false);
  };

  const handlereset = () => {
    setSelectedDateRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setIsCalendarOpen(false);
  };

  const formatDate = (dateString) => dayjs(dateString).format("MM-DD-YYYY");
  const formattedDate = formatDate(selectedDate);

  const fetchdata = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("auth");
      const response = await axios.get(
        `${BS_BASE}/patient_care_plan/list?patientid=${data?.patientid}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data && Array.isArray(response.data)) {
        const sortedData = response.data.sort((a, b) => {
          return new Date(b.ts) - new Date(a.ts);
        });
        setTableData(sortedData);
      } else setTableData([]);
    } catch (error) {
      console.log("Error fetching patient care plan:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (audiolink) => {
    try {
      setModalLoading(true);
      setModalOpen(true);
      const token = localStorage.getItem("auth");
      const res = await axios.get(
        `${BS_BASE}/patient_care_plan/care_plan/detail?audiolink=${audiolink}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setModalData(res.data);
    } catch (err) {
      console.error("Error fetching detail:", err);
      setModalData({ error: "Failed to fetch detail data" });
    } finally {
      setModalLoading(false);
    }
  };

  // Audio Recording Handlers
  const startRecording = async () => {
    setIsRecordingDisabled(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const chunks = [];
      const recorder = new MediaRecorder(stream);
      audioStreamRef.current = stream;

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.push(e.data);
      };

      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/webm" });
        setRecordedAudioBlob(blob);
        setShowSaveModal(true);
        clearInterval(timerRef.current);
        setRecordDuration(0);
      };

      recorder.start();
      setMediaRecorder(recorder);
      setAudioChunks(chunks); // store chunks reference
      setIsRecording(true);
      setIsPaused(false);

      timerRef.current = setInterval(() => {
        setRecordDuration((prev) => prev + 1);
      }, 1000);
    } catch (err) {
      console.error("Recording failed:", err);
    }
  };

  const saveRecording = async () => {
    setLoading(true);
    setIsRecordingDisabled(false);
    if (!recordedAudioBlob) {
      console.error("No audio blob found to upload");
      return;
    }

    try {
      const token = localStorage.getItem("auth");
      const formData = new FormData();
      const audioFile = new File([recordedAudioBlob], "recording.webm", {
        type: "audio/webm",
      });
      formData.append("audio_file", audioFile);
      formData.append("patientid", String(data.patientid)); // make sure it's a string

      const res = await axios.post(
        `${BS_BASE}/patient_care_plan/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      console.log("✅ Upload successful:", res.data);
      setShowSaveModal(false);
      fetchdata();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("❌ Upload failed:", err.response || err);
    } finally {
      setLoading(false);
    }
  };

  const pauseRecording = () => {
    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.pause();
      setIsPaused(true);
      clearInterval(timerRef.current);
    }
  };

  const resumeRecording = () => {
    if (mediaRecorder && mediaRecorder.state === "paused") {
      mediaRecorder.resume();
      setIsPaused(false);
      timerRef.current = setInterval(() => {
        setRecordDuration((prev) => prev + 1);
      }, 1000);
    }
  };

  const stopRecording = () => {
    setIsRecordingDisabled(false);
    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }
    if (mediaRecorder) {
      mediaRecorder.stop();
      setIsRecording(false);
      setIsPaused(false);
    }
  };

  const deleteRecording = () => {
    setShowSaveModal(false);
    setRecordedAudioBlob(null);
  };

const getpatientdata = async () => {
  try {
    setpatientloading(true)
const response = await api.get(`/v1/${practiseid}/patients`, {
  params: { patientid: data?.patientid },
});

  if (
    response?.status === 200 &&
    Array.isArray(response?.patients) &&
    response?.patients[0]
  ) {
    const patient = response.patients[0];

    if (patient?.ccm_enroll !== undefined && patient?.ccm_enroll !== null) {
      setEnrollPatientData(patient);
    } else {
      // optional: reset if no enroll data
      setEnrollPatientData(null);
    }
  } else {
    setEnrollPatientData(null);
  }

  } catch (error) {
    console.log(error)
  }finally{
    setpatientloading(false)
  }
}
  useEffect(() => {
    fetchdata();
   getpatientdata();
  }, []);
  const updateenrollmentstatus = async() => {
    try {
      setLoading(true)
    const response = await api.put(
  `/v1/${practiseid}/patients/${data?.patientid}/ccm_enroll`,
  {}, // empty body
  {
    params: {
      ccm_enroll: "Y",
    },
  }
);

if(response?.status===200){
    setShowEnrollModal(false);
}
    } catch (error) {
      console.log(error)
    }finally{
       getpatientdata();
       setLoading(false)
    }
   
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsCalendarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isToday = selectedDate.isSame(dayjs(), "day");

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };
const fetchAuditData=async(link)=>{
  try {
       const accessToken = localStorage.getItem('auth');
    setLoading(true)
const response = await axios.get(
  `${BS_BASE}/patient_care_plan/audit_trail/detail?audiolink=${link}`,
  {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    }
  }
);

    if(response.status==200){

      setAuditData(response?.data||{})


    }else{
      setAuditData([])
    }
    
  } catch (error) {
    console.log(error)
       setAuditData([])
  }finally{
          setShowAddModal(true)
setLoading(false)
  }
}
const insertAuditData=async(data)=>{
  try {
       const accessToken = localStorage.getItem('auth');
    setLoading(true)
const response = await axios.post(
  `${BS_BASE}/patient_care_plan/edit`,
data,
  {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    }
  }
);

    if(response.status==200){
fetchAuditData(data?.audiolink)

    }
    
  } catch (error) {
    console.log(error)
   
  }finally{
          setShowAddModal(true)
setLoading(false)
  }
}
const allinsertAuditData = async () => {
  try {
    const accessToken = localStorage.getItem('auth');
    setLoading(true);
    setAllAuditData([]);

    const response = await axios.get(
      `${BS_BASE}/audit_trail/list?patientid=${data?.patientid}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
       
          accept: 'application/json',
        },
      }
    );

    // assuming response.data holds the array
    setAllAuditData(response.data);
    setShowAuditModal(true);

  } catch (error) {
    console.error("Error fetching audit data:", error);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="w-full flex flex-col gap-4 relative mt-3">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Mic & Calendar Section */}
      <div className="relative flex items-center w-full px-4">
{ !patientloading ? (
  !enrollPatientData?.ccm_enroll || enrollPatientData?.ccm_enroll !== "Y" ? (
    <button
      className="flex justify-center items-center gap-2 bg-[#E17954] px-2 py-2 rounded-[10px] focus:outline-none"
      onClick={() => setShowEnrollModal(true)}
    >
      <div className="text-[#FFFFFF] font-semibold text-[16px]">
        Enroll Patient
      </div>
    </button>
  ) : (
    <div className="text-[#1D2951] text-[14px] font-semibold">
      Enrollment date:{" "}
      {enrollPatientData?.ccm_enroll_date
        ? dayjs(enrollPatientData.ccm_enroll_date).format("MM/DD/YYYY")
        : "--"}
    </div>
  )
) : null}


        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center z-10">
          {enrollPatientData?.ccm_enroll !== "Y"? (
            <div className=" bg-[#A7A7A7] flex flex-col justify-center items-center cursor-pointer w-14 h-14 rounded-full shadow-md p-2">
              {whitemic}
            </div>
          ) : (
            <div className="flex items-center">
              {!isRecording ? (
                // <img src={redmic} className="w-[35px] h-[35px]" alt="Mic" onClick={startRecording} />
                <div
                  onClick={startRecording}
                  className=" bg-[#EF4444] flex flex-col justify-center items-center cursor-pointer w-14 h-14 rounded-full shadow-md p-2"
                >
                  {whitemic}
                </div>
              ) : (
                <>
                  {/* Timer */}

                  {/* Pause / Stop buttons in row */}
                  <div className="flex gap-4 items-center">
                    <div
                      onClick={isPaused ? resumeRecording : pauseRecording}
                      className="cursor-pointer relative"
                    >
                      <img src={redcircle} className="w-[35px] h-[35px]" />
                      <img
                        src={!isPaused ? pause : play}
                        className="absolute inset-0 m-auto w-[16px] h-[16px]"
                        alt="Pause/Play"
                      />
                    </div>
                    {/* <div className="text-black font-mono font-bold text-sm mb-1">
                    {formatTime(recordDuration)}
                  </div> */}
                    <div className="flex flex-col items-center h-[90%] justify-between">
                      <div className="h-4 overflow-hidden">
                        <ReactiveWaves
                          isPaused={!isPaused}
                          mediaStream={audioStreamRef.current}
                        />
                      </div>
                      <div
                        className="h-3 text-black font-normal"
                        style={{ fontFamily: "Inter" }}
                      >
                        {formatTime(recordDuration)}
                      </div>
                    </div>
                    <div
                      onClick={stopRecording}
                      className="cursor-pointer relative"
                    >
                      <img src={redcircle} className="w-[35px] h-[35px]" />
                      <img
                        src={stop}
                        className="absolute inset-0 m-auto w-[16px] h-[16px]"
                        alt="Stop"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* Calendar */}
        {/* <div
          onClick={() => setIsCalendarOpen((prev) => !prev)}
          className=" relative ml-auto w-[120px] md:w-[141px] h-10 cursor-pointer bg-white rounded-[10px] flex items-end justify-between px-3 md:px-4"
        >
          <div className="flex flex-col">
            <span className="text-[8px] md:text-[9px] font-worksans text-[#3A3A49] font-medium text-left">
              {isToday ? "Today" : selectedDate.format("dddd")}
            </span>
            <Typography
              variant="h6"
              sx={{ fontSize: { xs: "12px", md: "14px" }, color: "#3A3A49" }}
            >
              {formattedDate}
            </Typography>
          </div>
          <img
            className="w-4 h-4 md:w-6 md:h-6"
            alt="Calendar Icon"
            src={calendericon}
          />

          {isCalendarOpen && (
            <>
              <div
                ref={calendarRef}
                className="fixed top-[30%] right-[20%] z-50 w-[300px] bg-white  shadow-lg rounded-xl"
              >
                <DateRangeSelector
                  onSubmit={handledateSelect}
                  selectedDateRange={selectedDateRange}
                  setSelectedDateRange={setSelectedDateRange}
                  handlereset={handlereset}
                />
              </div>
            </>
          )}
        </div> */}
        {enrollPatientData?.ccm_enroll == "Y" && (
          <button
            className="ml-2 focus:outline-none cursor:pointer"
            onClick={() => allinsertAuditData()}
          >
            {historyCCM}
          </button>
        )}
      </div>

      {/* Care Plan Table */}
      <CarePlanTable
        setSelectedRecord={setSelectedRecord}
        selectedRecord={selectedRecord}
        settype={setType}
        tableData={tableData}
        loading={loading}
        onView={handleView}
       lock={enrollPatientData?.ccm_enroll === "Y" ? false : true}
       fetchAuditData={fetchAuditData}
       showAddModal={showAddModal}
       setShowAddModal={setShowAddModal}
       insertAuditData={insertAuditData}
       auditData={auditData}

      />

      {/* {enrollPatientData?.ccm_enroll !== "Y" && (
        <div className="text-[#1D2951] text-[14px] font-medium font-opensans">
          Total hours for [Month]: 8h25m{" "}
        </div>
      )} */}

      {/* Care Plan Modal */}
      <CarePlanDynamicModal
        open={modalOpen}
        fetchdata={fetchdata}
        selectedRecord={selectedRecord}
        type={type}
        data={modalData}
        onClose={() => setModalOpen(false)}
        isLoading={modalLoading}
        isEdit={true}
      />

      {/* Save/Delete Recording Modal */}
      {showSaveModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white w-[360px] rounded-2xl shadow-lg relative animate-fadeIn">
            <button
              onClick={deleteRecording}
              className="absolute top-4 right-4 focus:outline-none"
            >
              <FontAwesomeIcon
                icon={faXmark}
                className="text-[#000000] text-[18px]"
              />
            </button>

            <div className="flex justify-center mb-3 pt-4">
              <div className="w-14 h-14 rounded-full bg-[#FFF3E9] flex items-center justify-center">
                {orangeFileIcon}
              </div>
            </div>

            <p className="text-center font-font1 text-[18px] font-bold text-[#111827] mb-2">
              Do you want to save?
            </p>

            {/* Buttons */}
            <div className="flex justify-between gap-4 mt-6 p-3 bg-[#F9FAFB] rounded-b-2xl">
              <button
                onClick={saveRecording}
                className="flex-1 border border-[#00000040] bg-[#FFFFFF] rounded-lg py-2.5 font-medium text-[#374151] transition text-[16px] font-font1 hover:bg-[#F97316] hover:text-[#fff]"
              >
                Save
              </button>
              <button
                onClick={deleteRecording}
                className="flex-1 border border-[#00000040] bg-[#FFFFFF] text-[#374151] rounded-lg py-2.5 font-medium hover:bg-[#F97316] hover:text-[#fff] transition text-[16px] font-font1"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <EnrollForm
        open={showEnrollModal}
        onClose={() => setShowEnrollModal(false)}
        onAccept={async () => {
          // await enroll API if needed
          
      updateenrollmentstatus()
        }}
        fileIcon={fileIcon}
      />
      <AuditTrailModal
        open={showAuditModal}
        auditData={allauditdata}
        onClose={() => setShowAuditModal(false)}
      />
    </div>
  );
};

export default CCmTable;
